export default "__VITE_ASSET__73495a65__"